import cloneDeep from 'lodash/cloneDeep'

export function getMenuTypeName(type) {
    if (type == 1) {
        return 'MENU_CATEGORY'
    } else if (type == 2) {
        return 'MENU_GROUP'
    } else if (type == 3) {
        return 'MENU_SUBMENU_CAT'
    } else if (type == 4) {
        return 'MENU_SUBMENU_LINK'
    } else if (type == 5) {
        return 'MENU_LINK'
    }
    return 'not defined'
}

export function getLangSlug() {
    let langSlug = localStorage.getItem('indy_lang_slug')
    return langSlug || 'en'
}

export function setLangSlug(langSlug) {
    localStorage.setItem('indy_lang_slug', langSlug)
}

export function getHomeRowBackground(colors, image) {
    if (image) {
        return `background-image: url(${image})`
    } else if (colors) {
        colors = colors.split(',')
        let countColors = colors.length
        if (countColors > 1) {
            let gradients = []
            colors.forEach((color, index) => {
                let gradient = `${color} ${(index * 100) / (countColors - 1)}%`
                gradients.push(gradient)
            })
            return `background-image: linear-gradient(135deg, ${gradients.join(
                ','
            )})`
        } else {
            return `background-color: ${colors[0]}`
        }
    } else {
        return ''
    }
}

export function getBackgroundTextColor(hex = '#ffffff') {
    const r = parseInt(hex.substring(1, 3), 16)
    const g = parseInt(hex.substring(3, 5), 16)
    const b = parseInt(hex.substring(5, 7), 16)
    const textColor = (r * 299 + g * 587 + b * 114) / 1000
    return textColor >= 132 ? '#000000' : '#ffffff'
}

export function getRandomColor() {
    var letters = '0123456789ABCDEF'
    var color = '#'
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
    }
    return color
}

export function removeKeyOfNull(obj) {
    let objData = { ...obj }
    Object.keys(objData).forEach(
        key => objData[key] == null && delete objData[key]
    )
    return objData
}

export function moveArray(originalArr, old_index, new_index) {
    let arr = cloneDeep(originalArr)
    while (old_index < 0) {
        old_index += arr.length
    }
    while (new_index < 0) {
        new_index += arr.length
    }
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1
        while (k--) {
            arr.push(undefined)
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
    return arr
}

export function insertArray(originalArr, index, newItems) {
    let arr = cloneDeep(originalArr)
    arr.splice(index, 0, newItems)
    return arr
}

function generateMenuListObject(item = {}, level = 1) {
    return {
        id: item.cat_ID,
        title: item.cat_name,
        url: item.url,
        icon: '',
        tag_color: '',
        tag_title: '',
        tag_effect: 'none',
        background_url: '',
        is_new_tab: false,
        submenu_style: 1,
        submenus:
            level < 3 && item.children && item.children.length > 0
                ? item.children.map(item =>
                      generateMenuListObject(item, level + 1)
                  )
                : []
    }
}

export function generateMenuListAuto(menuList = []) {
    let newList = menuList.map(item => generateMenuListObject(item, 1))
    return newList
}

function prepareFake(text) {
    let isRTL = document.documentElement.getAttribute('dir') == 'rtl'
    let fakeEl = document.createElement('textarea')
    fakeEl.style.position = 'absolute'
    fakeEl.style[isRTL ? 'right' : 'left'] = '-9999px'
    fakeEl.style.top =
        (window.pageYOffset || document.documentElement.scrollTop) + 'px'
    fakeEl.setAttribute('readonly', '')
    fakeEl.value = text
    document.body.appendChild(fakeEl)
    fakeEl.focus()
    fakeEl.setSelectionRange(0, fakeEl.value.length)
    return fakeEl
}

export function copyToClipboard(text) {
    let fake = prepareFake(text)
    document.execCommand('copy')
    document.body.removeChild(fake)
}
